import { dismissTender, fetchTenders, setTenderQualification } from '../../services/tenders';
import { notify } from '../../store/feedback';
import { tenderToDealForm } from './tenderToDealForm';

/* Appels d'offres : chargement, qualification, écartement et ouverture de la conversion en affaire. */
export default function tenderQualificationHandlers(deps, api) {
  const { closeModal, crmClients, form, modalData, openModal, setTendersLoaded, setTenders } = deps;

  // ── CRM : appels d'offres BOAMP (sync + scoring automatiques, voir supabase/functions/boamp-sync) ──
  async function loadTenders() {
    const { data, error } = await fetchTenders();
    if (error) {
      console.error(error);
      notify("Erreur chargement des appels d'offres : " + error.message);
      return;
    }
    setTenders(data || []);
    setTendersLoaded(true);
  }

  async function saveTenderQualification(idweb, qualification_status) {
    const { error } = await setTenderQualification(idweb, qualification_status);
    if (error) {
      notify('Erreur enregistrement : ' + error.message);
      return;
    }
    setTenders((list) => list.map((n) => (n.idweb === idweb ? { ...n, qualification_status } : n)));
  }

  async function saveTenderDismissal() {
    const n = modalData.notice;
    const f = form;
    const motif =
      f.motif === 'Autre erreur de tri' || f.motif === 'Autre raison'
        ? (f.motifLibre || '').trim()
        : f.motif;
    if (!motif) {
      notify('Motif requis.');
      return;
    }
    const { error } = await dismissTender(f, motif, n);
    if (error) {
      notify('Erreur enregistrement : ' + error.message);
      return;
    }
    setTenders((list) =>
      list.map((x) =>
        x.idweb === n.idweb
          ? {
              ...x,
              qualification_status: 'ecarte',
              ecarte_motif_categorie: f.categorie,
              ecarte_motif: motif,
            }
          : x,
      ),
    );
    closeModal();
  }

  // Ouvre la fenêtre de confirmation de conversion AO → affaire, avec correspondance client et
  // secteur pré-remplies (jamais appliquées automatiquement sans relecture — voir plan du 2026-09-03).
  function openTenderToDeal(n) {
    openModal('ao_to_affaire', { notice: n }, tenderToDealForm(n, crmClients));
  }

  return { loadTenders, saveTenderQualification, saveTenderDismissal, openTenderToDeal };
}
